import { format } from 'date-fns'

export const LOCAL_DATE_TIME_WITHOUT_TZ_FORMAT = 'yyyy-MM-dd\'T\'HH:mm:ss'

export const formatToLocalDateTimeString = (
  localDateTimeAsString: string | null,
): string => {
  if (localDateTimeAsString === null) {
    return ''
  }
  return format(new Date(localDateTimeAsString), LOCAL_DATE_TIME_WITHOUT_TZ_FORMAT)
}
export const formatToIsoDateTimeString = (
  isoDateTimeAsString: string,
): string => {
  if (isoDateTimeAsString == null || isoDateTimeAsString === '') {
    return ''
  }
  return new Date(isoDateTimeAsString).toISOString()
}
